var x;
(function(t) {
  t.assertEqual = (s) => s;
  function e(s) {
  }
  t.assertIs = e;
  function r(s) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, t.getValidEnumValues = (s) => {
    const a = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return t.objectValues(i);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(a) {
    return s[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, t.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(x || (x = {}));
var we;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(we || (we = {}));
const l = x.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), P = (t) => {
  switch (typeof t) {
    case "undefined":
      return l.undefined;
    case "string":
      return l.string;
    case "number":
      return isNaN(t) ? l.nan : l.number;
    case "boolean":
      return l.boolean;
    case "function":
      return l.function;
    case "bigint":
      return l.bigint;
    case "symbol":
      return l.symbol;
    case "object":
      return Array.isArray(t) ? l.array : t === null ? l.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? l.promise : typeof Map < "u" && t instanceof Map ? l.map : typeof Set < "u" && t instanceof Set ? l.set : typeof Date < "u" && t instanceof Date ? l.date : l.object;
    default:
      return l.unknown;
  }
}, c = x.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), tt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class C extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, n = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, f = 0;
          for (; f < i.path.length; ) {
            const u = i.path[f];
            f === i.path.length - 1 ? (o[u] = o[u] || { _errors: [] }, o[u]._errors.push(r(i))) : o[u] = o[u] || { _errors: [] }, o = o[u], f++;
          }
        }
    };
    return s(this), n;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, x.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
C.create = (t) => new C(t);
const G = (t, e) => {
  let r;
  switch (t.code) {
    case c.invalid_type:
      t.received === l.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case c.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, x.jsonStringifyReplacer)}`;
      break;
    case c.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${x.joinValues(t.keys, ", ")}`;
      break;
    case c.invalid_union:
      r = "Invalid input";
      break;
    case c.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${x.joinValues(t.options)}`;
      break;
    case c.invalid_enum_value:
      r = `Invalid enum value. Expected ${x.joinValues(t.options)}, received '${t.received}'`;
      break;
    case c.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case c.invalid_return_type:
      r = "Invalid function return type";
      break;
    case c.invalid_date:
      r = "Invalid date";
      break;
    case c.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : x.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case c.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case c.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case c.custom:
      r = "Invalid input";
      break;
    case c.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case c.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case c.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, x.assertNever(t);
  }
  return { message: r };
};
let Le = G;
function rt(t) {
  Le = t;
}
function de() {
  return Le;
}
const ue = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: s } = t, a = [...r, ...s.path || []], i = {
    ...s,
    path: a
  };
  let o = "";
  const f = n.filter((u) => !!u).slice().reverse();
  for (const u of f)
    o = u(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: s.message || o
  };
}, nt = [];
function h(t, e) {
  const r = ue({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      t.schemaErrorMap,
      de(),
      G
      // then global default map
    ].filter((n) => !!n)
  });
  t.common.issues.push(r);
}
class k {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const s of r)
      n.push({
        key: await s.key,
        value: await s.value
      });
    return k.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const s of r) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return y;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (n[a.value] = i.value);
    }
    return { status: e.value, value: n };
  }
}
const y = Object.freeze({
  status: "aborted"
}), De = (t) => ({ status: "dirty", value: t }), w = (t) => ({ status: "valid", value: t }), Se = (t) => t.status === "aborted", Te = (t) => t.status === "dirty", Y = (t) => t.status === "valid", le = (t) => typeof Promise < "u" && t instanceof Promise;
var p;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(p || (p = {}));
class A {
  constructor(e, r, n, s) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const je = (t, e) => {
  if (Y(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new C(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function g(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: s } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => i.code !== "invalid_type" ? { message: o.defaultError } : typeof o.data > "u" ? { message: n ?? o.defaultError } : { message: r ?? o.defaultError }, description: s };
}
class v {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return P(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: P(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new k(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: P(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (le(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: P(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return je(s, a);
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: P(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), a = await (le(s) ? s : Promise.resolve(s));
    return je(n, a);
  }
  refine(e, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: c.custom,
        ...n(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((f) => f ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(e) {
    return new Z({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return O.create(this, this._def);
  }
  nullable() {
    return U.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return N.create(this, this._def);
  }
  promise() {
    return W.create(this, this._def);
  }
  or(e) {
    return X.create([this, e], this._def);
  }
  and(e) {
    return Q.create(this, e, this._def);
  }
  transform(e) {
    return new Z({
      ...g(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new ne({
      ...g(this._def),
      innerType: this,
      defaultValue: r,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new $e({
      typeName: m.ZodBranded,
      type: this,
      ...g(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new me({
      ...g(this._def),
      innerType: this,
      catchValue: r,
      typeName: m.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return se.create(this, e);
  }
  readonly() {
    return ge.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const st = /^c[^\s-]{8,}$/i, at = /^[a-z][a-z0-9]*$/, it = /^[0-9A-HJKMNP-TV-Z]{26}$/, ot = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, ct = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, dt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ke;
const ut = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, lt = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, ht = (t) => t.precision ? t.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${t.precision}}Z$`) : t.precision === 0 ? t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : t.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function ft(t, e) {
  return !!((e === "v4" || !e) && ut.test(t) || (e === "v6" || !e) && lt.test(t));
}
class T extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== l.string) {
      const a = this._getOrReturnCtx(e);
      return h(
        a,
        {
          code: c.invalid_type,
          expected: l.string,
          received: a.parsedType
        }
        //
      ), y;
    }
    const n = new k();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), h(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), h(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), n.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? h(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && h(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), n.dirty());
      } else if (a.kind === "email")
        ct.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "email",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "emoji")
        ke || (ke = new RegExp(dt, "u")), ke.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "emoji",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "uuid")
        ot.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "uuid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid")
        st.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "cuid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "cuid2")
        at.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "cuid2",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "ulid")
        it.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "ulid",
          code: c.invalid_string,
          message: a.message
        }), n.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), h(s, {
            validation: "url",
            code: c.invalid_string,
            message: a.message
          }), n.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "regex",
          code: c.invalid_string,
          message: a.message
        }), n.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), h(s, {
          code: c.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), n.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), h(s, {
          code: c.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), n.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), h(s, {
          code: c.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), n.dirty()) : a.kind === "datetime" ? ht(a).test(e.data) || (s = this._getOrReturnCtx(e, s), h(s, {
          code: c.invalid_string,
          validation: "datetime",
          message: a.message
        }), n.dirty()) : a.kind === "ip" ? ft(e.data, a.version) || (s = this._getOrReturnCtx(e, s), h(s, {
          validation: "ip",
          code: c.invalid_string,
          message: a.message
        }), n.dirty()) : x.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((s) => e.test(s), {
      validation: r,
      code: c.invalid_string,
      ...p.errToObj(n)
    });
  }
  _addCheck(e) {
    return new T({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...p.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...p.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...p.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...p.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...p.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...p.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...p.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...p.errToObj(e) });
  }
  datetime(e) {
    var r;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      ...p.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...p.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...p.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...p.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...p.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...p.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...p.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...p.errToObj(r)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, p.errToObj(e));
  }
  trim() {
    return new T({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new T({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new T({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
T.create = (t) => {
  var e;
  return new T({
    checks: [],
    typeName: m.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...g(t)
  });
};
function pt(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = r > n ? r : n, a = parseInt(t.toFixed(s).replace(".", "")), i = parseInt(e.toFixed(s).replace(".", ""));
  return a % i / Math.pow(10, s);
}
class M extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== l.number) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: l.number,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new k();
    for (const a of this._def.checks)
      a.kind === "int" ? x.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? pt(e.data, a.value) !== 0 && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.not_finite,
        message: a.message
      }), s.dirty()) : x.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, p.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, p.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, p.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, p.toString(r));
  }
  setLimit(e, r, n, s) {
    return new M({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: p.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new M({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: p.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: p.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: p.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: p.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && x.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
M.create = (t) => new M({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...g(t)
});
class I extends v {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== l.bigint) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: l.bigint,
        received: a.parsedType
      }), y;
    }
    let n;
    const s = new k();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), h(n, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : x.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, p.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, p.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, p.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, p.toString(r));
  }
  setLimit(e, r, n, s) {
    return new I({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: p.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new I({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: p.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: p.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: p.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
I.create = (t) => {
  var e;
  return new I({
    checks: [],
    typeName: m.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...g(t)
  });
};
class H extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== l.boolean) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: c.invalid_type,
        expected: l.boolean,
        received: n.parsedType
      }), y;
    }
    return w(e.data);
  }
}
H.create = (t) => new H({
  typeName: m.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...g(t)
});
class V extends v {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== l.date) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_type,
        expected: l.date,
        received: a.parsedType
      }), y;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return h(a, {
        code: c.invalid_date
      }), y;
    }
    const n = new k();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), h(s, {
        code: c.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), n.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), h(s, {
        code: c.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), n.dirty()) : x.assertNever(a);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new V({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: p.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: p.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
V.create = (t) => new V({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: m.ZodDate,
  ...g(t)
});
class he extends v {
  _parse(e) {
    if (this._getType(e) !== l.symbol) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: c.invalid_type,
        expected: l.symbol,
        received: n.parsedType
      }), y;
    }
    return w(e.data);
  }
}
he.create = (t) => new he({
  typeName: m.ZodSymbol,
  ...g(t)
});
class J extends v {
  _parse(e) {
    if (this._getType(e) !== l.undefined) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: c.invalid_type,
        expected: l.undefined,
        received: n.parsedType
      }), y;
    }
    return w(e.data);
  }
}
J.create = (t) => new J({
  typeName: m.ZodUndefined,
  ...g(t)
});
class K extends v {
  _parse(e) {
    if (this._getType(e) !== l.null) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: c.invalid_type,
        expected: l.null,
        received: n.parsedType
      }), y;
    }
    return w(e.data);
  }
}
K.create = (t) => new K({
  typeName: m.ZodNull,
  ...g(t)
});
class q extends v {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return w(e.data);
  }
}
q.create = (t) => new q({
  typeName: m.ZodAny,
  ...g(t)
});
class D extends v {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return w(e.data);
  }
}
D.create = (t) => new D({
  typeName: m.ZodUnknown,
  ...g(t)
});
class R extends v {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return h(r, {
      code: c.invalid_type,
      expected: l.never,
      received: r.parsedType
    }), y;
  }
}
R.create = (t) => new R({
  typeName: m.ZodNever,
  ...g(t)
});
class fe extends v {
  _parse(e) {
    if (this._getType(e) !== l.undefined) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: c.invalid_type,
        expected: l.void,
        received: n.parsedType
      }), y;
    }
    return w(e.data);
  }
}
fe.create = (t) => new fe({
  typeName: m.ZodVoid,
  ...g(t)
});
class N extends v {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), s = this._def;
    if (r.parsedType !== l.array)
      return h(r, {
        code: c.invalid_type,
        expected: l.array,
        received: r.parsedType
      }), y;
    if (s.exactLength !== null) {
      const i = r.data.length > s.exactLength.value, o = r.data.length < s.exactLength.value;
      (i || o) && (h(r, {
        code: i ? c.too_big : c.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (h(r, {
      code: c.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (h(r, {
      code: c.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => s.type._parseAsync(new A(r, i, r.path, o)))).then((i) => k.mergeArray(n, i));
    const a = [...r.data].map((i, o) => s.type._parseSync(new A(r, i, r.path, o)));
    return k.mergeArray(n, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new N({
      ...this._def,
      minLength: { value: e, message: p.toString(r) }
    });
  }
  max(e, r) {
    return new N({
      ...this._def,
      maxLength: { value: e, message: p.toString(r) }
    });
  }
  length(e, r) {
    return new N({
      ...this._def,
      exactLength: { value: e, message: p.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
N.create = (t, e) => new N({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ...g(e)
});
function z(t) {
  if (t instanceof b) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = O.create(z(n));
    }
    return new b({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof N ? new N({
      ...t._def,
      type: z(t.element)
    }) : t instanceof O ? O.create(z(t.unwrap())) : t instanceof U ? U.create(z(t.unwrap())) : t instanceof E ? E.create(t.items.map((e) => z(e))) : t;
}
class b extends v {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = x.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== l.object) {
      const u = this._getOrReturnCtx(e);
      return h(u, {
        code: c.invalid_type,
        expected: l.object,
        received: u.parsedType
      }), y;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof R && this._def.unknownKeys === "strip"))
      for (const u in s.data)
        i.includes(u) || o.push(u);
    const f = [];
    for (const u of i) {
      const _ = a[u], S = s.data[u];
      f.push({
        key: { status: "valid", value: u },
        value: _._parse(new A(s, S, s.path, u)),
        alwaysSet: u in s.data
      });
    }
    if (this._def.catchall instanceof R) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const _ of o)
          f.push({
            key: { status: "valid", value: _ },
            value: { status: "valid", value: s.data[_] }
          });
      else if (u === "strict")
        o.length > 0 && (h(s, {
          code: c.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const _ of o) {
        const S = s.data[_];
        f.push({
          key: { status: "valid", value: _ },
          value: u._parse(
            new A(s, S, s.path, _)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: _ in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const _ of f) {
        const S = await _.key;
        u.push({
          key: S,
          value: await _.value,
          alwaysSet: _.alwaysSet
        });
      }
      return u;
    }).then((u) => k.mergeObjectSync(n, u)) : k.mergeObjectSync(n, f);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return p.errToObj, new b({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var s, a, i, o;
          const f = (i = (a = (s = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(s, r, n).message) !== null && i !== void 0 ? i : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = p.errToObj(e).message) !== null && o !== void 0 ? o : f
          } : {
            message: f
          };
        }
      } : {}
    });
  }
  strip() {
    return new b({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new b({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new b({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new b({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new b({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return x.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new b({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return x.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new b({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return z(this);
  }
  partial(e) {
    const r = {};
    return x.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      e && !e[n] ? r[n] = s : r[n] = s.optional();
    }), new b({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return x.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let a = this.shape[n];
        for (; a instanceof O; )
          a = a._def.innerType;
        r[n] = a;
      }
    }), new b({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Ve(x.objectKeys(this.shape));
  }
}
b.create = (t, e) => new b({
  shape: () => t,
  unknownKeys: "strip",
  catchall: R.create(),
  typeName: m.ZodObject,
  ...g(e)
});
b.strictCreate = (t, e) => new b({
  shape: () => t,
  unknownKeys: "strict",
  catchall: R.create(),
  typeName: m.ZodObject,
  ...g(e)
});
b.lazycreate = (t, e) => new b({
  shape: t,
  unknownKeys: "strip",
  catchall: R.create(),
  typeName: m.ZodObject,
  ...g(e)
});
class X extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new C(o.ctx.common.issues));
      return h(r, {
        code: c.invalid_union,
        unionErrors: i
      }), y;
    }
    if (r.common.async)
      return Promise.all(n.map(async (a) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const f of n) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, _ = f._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (_.status === "valid")
          return _;
        _.status === "dirty" && !a && (a = { result: _, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((f) => new C(f));
      return h(r, {
        code: c.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
X.create = (t, e) => new X({
  options: t,
  typeName: m.ZodUnion,
  ...g(e)
});
const ce = (t) => t instanceof ee ? ce(t.schema) : t instanceof Z ? ce(t.innerType()) : t instanceof te ? [t.value] : t instanceof L ? t.options : t instanceof re ? Object.keys(t.enum) : t instanceof ne ? ce(t._def.innerType) : t instanceof J ? [void 0] : t instanceof K ? [null] : null;
class xe extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.object)
      return h(r, {
        code: c.invalid_type,
        expected: l.object,
        received: r.parsedType
      }), y;
    const n = this.discriminator, s = r.data[n], a = this.optionsMap.get(s);
    return a ? r.common.async ? a._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : a._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (h(r, {
      code: c.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), y);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const a of r) {
      const i = ce(a.shape[e]);
      if (!i)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, a);
      }
    }
    return new xe({
      typeName: m.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: s,
      ...g(n)
    });
  }
}
function Ce(t, e) {
  const r = P(t), n = P(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === l.object && n === l.object) {
    const s = x.objectKeys(e), a = x.objectKeys(t).filter((o) => s.indexOf(o) !== -1), i = { ...t, ...e };
    for (const o of a) {
      const f = Ce(t[o], e[o]);
      if (!f.valid)
        return { valid: !1 };
      i[o] = f.data;
    }
    return { valid: !0, data: i };
  } else if (r === l.array && n === l.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < t.length; a++) {
      const i = t[a], o = e[a], f = Ce(i, o);
      if (!f.valid)
        return { valid: !1 };
      s.push(f.data);
    }
    return { valid: !0, data: s };
  } else
    return r === l.date && n === l.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class Q extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = (a, i) => {
      if (Se(a) || Se(i))
        return y;
      const o = Ce(a.value, i.value);
      return o.valid ? ((Te(a) || Te(i)) && r.dirty(), { status: r.value, value: o.data }) : (h(n, {
        code: c.invalid_intersection_types
      }), y);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
Q.create = (t, e, r) => new Q({
  left: t,
  right: e,
  typeName: m.ZodIntersection,
  ...g(r)
});
class E extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.array)
      return h(n, {
        code: c.invalid_type,
        expected: l.array,
        received: n.parsedType
      }), y;
    if (n.data.length < this._def.items.length)
      return h(n, {
        code: c.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && n.data.length > this._def.items.length && (h(n, {
      code: c.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...n.data].map((i, o) => {
      const f = this._def.items[o] || this._def.rest;
      return f ? f._parse(new A(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(a).then((i) => k.mergeArray(r, i)) : k.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new E({
      ...this._def,
      rest: e
    });
  }
}
E.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new E({
    items: t,
    typeName: m.ZodTuple,
    rest: null,
    ...g(e)
  });
};
class F extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.object)
      return h(n, {
        code: c.invalid_type,
        expected: l.object,
        received: n.parsedType
      }), y;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      s.push({
        key: a._parse(new A(n, o, n.path, o)),
        value: i._parse(new A(n, n.data[o], n.path, o))
      });
    return n.common.async ? k.mergeObjectAsync(r, s) : k.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof v ? new F({
      keyType: e,
      valueType: r,
      typeName: m.ZodRecord,
      ...g(n)
    }) : new F({
      keyType: T.create(),
      valueType: e,
      typeName: m.ZodRecord,
      ...g(r)
    });
  }
}
class pe extends v {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.map)
      return h(n, {
        code: c.invalid_type,
        expected: l.map,
        received: n.parsedType
      }), y;
    const s = this._def.keyType, a = this._def.valueType, i = [...n.data.entries()].map(([o, f], u) => ({
      key: s._parse(new A(n, o, n.path, [u, "key"])),
      value: a._parse(new A(n, f, n.path, [u, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const f of i) {
          const u = await f.key, _ = await f.value;
          if (u.status === "aborted" || _.status === "aborted")
            return y;
          (u.status === "dirty" || _.status === "dirty") && r.dirty(), o.set(u.value, _.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const f of i) {
        const u = f.key, _ = f.value;
        if (u.status === "aborted" || _.status === "aborted")
          return y;
        (u.status === "dirty" || _.status === "dirty") && r.dirty(), o.set(u.value, _.value);
      }
      return { status: r.value, value: o };
    }
  }
}
pe.create = (t, e, r) => new pe({
  valueType: e,
  keyType: t,
  typeName: m.ZodMap,
  ...g(r)
});
class $ extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== l.set)
      return h(n, {
        code: c.invalid_type,
        expected: l.set,
        received: n.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (h(n, {
      code: c.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (h(n, {
      code: c.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function i(f) {
      const u = /* @__PURE__ */ new Set();
      for (const _ of f) {
        if (_.status === "aborted")
          return y;
        _.status === "dirty" && r.dirty(), u.add(_.value);
      }
      return { status: r.value, value: u };
    }
    const o = [...n.data.values()].map((f, u) => a._parse(new A(n, f, n.path, u)));
    return n.common.async ? Promise.all(o).then((f) => i(f)) : i(o);
  }
  min(e, r) {
    return new $({
      ...this._def,
      minSize: { value: e, message: p.toString(r) }
    });
  }
  max(e, r) {
    return new $({
      ...this._def,
      maxSize: { value: e, message: p.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
$.create = (t, e) => new $({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ...g(e)
});
class B extends v {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.function)
      return h(r, {
        code: c.invalid_type,
        expected: l.function,
        received: r.parsedType
      }), y;
    function n(o, f) {
      return ue({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          de(),
          G
        ].filter((u) => !!u),
        issueData: {
          code: c.invalid_arguments,
          argumentsError: f
        }
      });
    }
    function s(o, f) {
      return ue({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          de(),
          G
        ].filter((u) => !!u),
        issueData: {
          code: c.invalid_return_type,
          returnTypeError: f
        }
      });
    }
    const a = { errorMap: r.common.contextualErrorMap }, i = r.data;
    if (this._def.returns instanceof W) {
      const o = this;
      return w(async function(...f) {
        const u = new C([]), _ = await o._def.args.parseAsync(f, a).catch((be) => {
          throw u.addIssue(n(f, be)), u;
        }), S = await Reflect.apply(i, this, _);
        return await o._def.returns._def.type.parseAsync(S, a).catch((be) => {
          throw u.addIssue(s(S, be)), u;
        });
      });
    } else {
      const o = this;
      return w(function(...f) {
        const u = o._def.args.safeParse(f, a);
        if (!u.success)
          throw new C([n(f, u.error)]);
        const _ = Reflect.apply(i, this, u.data), S = o._def.returns.safeParse(_, a);
        if (!S.success)
          throw new C([s(_, S.error)]);
        return S.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new B({
      ...this._def,
      args: E.create(e).rest(D.create())
    });
  }
  returns(e) {
    return new B({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new B({
      args: e || E.create([]).rest(D.create()),
      returns: r || D.create(),
      typeName: m.ZodFunction,
      ...g(n)
    });
  }
}
class ee extends v {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
ee.create = (t, e) => new ee({
  getter: t,
  typeName: m.ZodLazy,
  ...g(e)
});
class te extends v {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return h(r, {
        received: r.data,
        code: c.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
te.create = (t, e) => new te({
  value: t,
  typeName: m.ZodLiteral,
  ...g(e)
});
function Ve(t, e) {
  return new L({
    values: t,
    typeName: m.ZodEnum,
    ...g(e)
  });
}
class L extends v {
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return h(r, {
        expected: x.joinValues(n),
        received: r.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return h(r, {
        received: r.data,
        code: c.invalid_enum_value,
        options: n
      }), y;
    }
    return w(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e) {
    return L.create(e);
  }
  exclude(e) {
    return L.create(this.options.filter((r) => !e.includes(r)));
  }
}
L.create = Ve;
class re extends v {
  _parse(e) {
    const r = x.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== l.string && n.parsedType !== l.number) {
      const s = x.objectValues(r);
      return h(n, {
        expected: x.joinValues(s),
        received: n.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (r.indexOf(e.data) === -1) {
      const s = x.objectValues(r);
      return h(n, {
        received: n.data,
        code: c.invalid_enum_value,
        options: s
      }), y;
    }
    return w(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
re.create = (t, e) => new re({
  values: t,
  typeName: m.ZodNativeEnum,
  ...g(e)
});
class W extends v {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== l.promise && r.common.async === !1)
      return h(r, {
        code: c.invalid_type,
        expected: l.promise,
        received: r.parsedType
      }), y;
    const n = r.parsedType === l.promise ? r.data : Promise.resolve(r.data);
    return w(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
W.create = (t, e) => new W({
  type: t,
  typeName: m.ZodPromise,
  ...g(e)
});
class Z extends v {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        h(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(n.data, a);
      return n.common.issues.length ? {
        status: "dirty",
        value: n.data
      } : n.common.async ? Promise.resolve(i).then((o) => this._def.schema._parseAsync({
        data: o,
        path: n.path,
        parent: n
      })) : this._def.schema._parseSync({
        data: i,
        path: n.path,
        parent: n
      });
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const f = s.refinement(o, a);
        if (n.common.async)
          return Promise.resolve(f);
        if (f instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Y(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => Y(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({ status: r.value, value: o })) : i);
    x.assertNever(s);
  }
}
Z.create = (t, e, r) => new Z({
  schema: t,
  typeName: m.ZodEffects,
  effect: e,
  ...g(r)
});
Z.createWithPreprocess = (t, e, r) => new Z({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: m.ZodEffects,
  ...g(r)
});
class O extends v {
  _parse(e) {
    return this._getType(e) === l.undefined ? w(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
O.create = (t, e) => new O({
  innerType: t,
  typeName: m.ZodOptional,
  ...g(e)
});
class U extends v {
  _parse(e) {
    return this._getType(e) === l.null ? w(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
U.create = (t, e) => new U({
  innerType: t,
  typeName: m.ZodNullable,
  ...g(e)
});
class ne extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === l.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ne.create = (t, e) => new ne({
  innerType: t,
  typeName: m.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...g(e)
});
class me extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return le(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new C(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new C(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
me.create = (t, e) => new me({
  innerType: t,
  typeName: m.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...g(e)
});
class ye extends v {
  _parse(e) {
    if (this._getType(e) !== l.nan) {
      const n = this._getOrReturnCtx(e);
      return h(n, {
        code: c.invalid_type,
        expected: l.nan,
        received: n.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
ye.create = (t) => new ye({
  typeName: m.ZodNaN,
  ...g(t)
});
const mt = Symbol("zod_brand");
class $e extends v {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class se extends v {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return a.status === "aborted" ? y : a.status === "dirty" ? (r.dirty(), De(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new se({
      in: e,
      out: r,
      typeName: m.ZodPipeline
    });
  }
}
class ge extends v {
  _parse(e) {
    const r = this._def.innerType._parse(e);
    return Y(r) && (r.value = Object.freeze(r.value)), r;
  }
}
ge.create = (t, e) => new ge({
  innerType: t,
  typeName: m.ZodReadonly,
  ...g(e)
});
const Ue = (t, e = {}, r) => t ? q.create().superRefine((n, s) => {
  var a, i;
  if (!t(n)) {
    const o = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, f = (i = (a = o.fatal) !== null && a !== void 0 ? a : r) !== null && i !== void 0 ? i : !0, u = typeof o == "string" ? { message: o } : o;
    s.addIssue({ code: "custom", ...u, fatal: f });
  }
}) : q.create(), yt = {
  object: b.lazycreate
};
var m;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const gt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => Ue((r) => r instanceof t, e), ze = T.create, Be = M.create, vt = ye.create, _t = I.create, qe = H.create, xt = V.create, bt = he.create, kt = J.create, wt = K.create, St = q.create, Tt = D.create, Ct = R.create, Nt = fe.create, Zt = N.create, At = b.create, Et = b.strictCreate, Ot = X.create, Rt = xe.create, jt = Q.create, Pt = E.create, Mt = F.create, It = pe.create, Lt = $.create, Dt = B.create, Vt = ee.create, $t = te.create, Ut = L.create, zt = re.create, Bt = W.create, Pe = Z.create, qt = O.create, Wt = U.create, Gt = Z.createWithPreprocess, Yt = se.create, Ht = () => ze().optional(), Jt = () => Be().optional(), Kt = () => qe().optional(), Xt = {
  string: (t) => T.create({ ...t, coerce: !0 }),
  number: (t) => M.create({ ...t, coerce: !0 }),
  boolean: (t) => H.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => I.create({ ...t, coerce: !0 }),
  date: (t) => V.create({ ...t, coerce: !0 })
}, Qt = y;
var d = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: G,
  setErrorMap: rt,
  getErrorMap: de,
  makeIssue: ue,
  EMPTY_PATH: nt,
  addIssueToContext: h,
  ParseStatus: k,
  INVALID: y,
  DIRTY: De,
  OK: w,
  isAborted: Se,
  isDirty: Te,
  isValid: Y,
  isAsync: le,
  get util() {
    return x;
  },
  get objectUtil() {
    return we;
  },
  ZodParsedType: l,
  getParsedType: P,
  ZodType: v,
  ZodString: T,
  ZodNumber: M,
  ZodBigInt: I,
  ZodBoolean: H,
  ZodDate: V,
  ZodSymbol: he,
  ZodUndefined: J,
  ZodNull: K,
  ZodAny: q,
  ZodUnknown: D,
  ZodNever: R,
  ZodVoid: fe,
  ZodArray: N,
  ZodObject: b,
  ZodUnion: X,
  ZodDiscriminatedUnion: xe,
  ZodIntersection: Q,
  ZodTuple: E,
  ZodRecord: F,
  ZodMap: pe,
  ZodSet: $,
  ZodFunction: B,
  ZodLazy: ee,
  ZodLiteral: te,
  ZodEnum: L,
  ZodNativeEnum: re,
  ZodPromise: W,
  ZodEffects: Z,
  ZodTransformer: Z,
  ZodOptional: O,
  ZodNullable: U,
  ZodDefault: ne,
  ZodCatch: me,
  ZodNaN: ye,
  BRAND: mt,
  ZodBranded: $e,
  ZodPipeline: se,
  ZodReadonly: ge,
  custom: Ue,
  Schema: v,
  ZodSchema: v,
  late: yt,
  get ZodFirstPartyTypeKind() {
    return m;
  },
  coerce: Xt,
  any: St,
  array: Zt,
  bigint: _t,
  boolean: qe,
  date: xt,
  discriminatedUnion: Rt,
  effect: Pe,
  enum: Ut,
  function: Dt,
  instanceof: gt,
  intersection: jt,
  lazy: Vt,
  literal: $t,
  map: It,
  nan: vt,
  nativeEnum: zt,
  never: Ct,
  null: wt,
  nullable: Wt,
  number: Be,
  object: At,
  oboolean: Kt,
  onumber: Jt,
  optional: qt,
  ostring: Ht,
  pipeline: Yt,
  preprocess: Gt,
  promise: Bt,
  record: Mt,
  set: Lt,
  strictObject: Et,
  string: ze,
  symbol: bt,
  transformer: Pe,
  tuple: Pt,
  undefined: kt,
  union: Ot,
  unknown: Tt,
  void: Nt,
  NEVER: Qt,
  ZodIssueCode: c,
  quotelessJson: tt,
  ZodError: C
});
const We = d.record(d.string()), Ge = d.object({
  centAmount: d.number()
}).passthrough(), Ft = d.object({
  value: Ge
}).passthrough(), er = d.object({
  name: d.string(),
  value: d.any()
}), tr = d.object({
  attributes: d.array(er).optional(),
  sku: d.string().optional()
}).passthrough(), Ze = d.object({
  fields: d.record(d.any())
}).passthrough(), rr = d.object({
  key: d.string().optional()
}).passthrough(), nr = d.object({
  obj: rr.optional()
}).passthrough(), ve = d.object({
  type: d.literal("centPrecision"),
  centAmount: d.number(),
  currencyCode: d.string(),
  fractionDigits: d.number()
}), sr = d.object({
  custom: Ze.optional(),
  id: d.string(),
  lineItemMode: d.union([d.literal("GiftLineItem"), d.literal("Standard")]),
  name: We,
  price: Ft,
  productType: nr,
  quantity: d.number(),
  totalPrice: Ge,
  variant: tr
}).passthrough(), ar = d.object({
  custom: Ze.optional(),
  id: d.string(),
  name: We,
  quantity: d.number()
}).passthrough(), ir = d.object({
  code: d.string()
}).passthrough(), or = d.object({
  obj: ir.optional()
}).passthrough(), cr = d.object({
  discountCode: or,
  state: d.union([
    d.literal("ApplicationStoppedByPreviousDiscount"),
    d.literal("DoesNotMatchCart"),
    d.literal("MatchesCart"),
    d.literal("MaxApplicationReached"),
    d.literal("NotActive"),
    d.literal("NotValid"),
    d.string()
  ])
}).passthrough(), dr = d.object({
  totalNet: ve,
  totalGross: ve
}).passthrough(), ur = d.object({
  id: d.string()
}).passthrough(), lr = d.union([
  d.literal("DoesNotMatchCart"),
  d.literal("MatchesCart"),
  d.string()
]), hr = d.object({
  shippingMethodName: d.string(),
  price: ve,
  shippingMethod: ur.optional(),
  shippingMethodState: lr
}).passthrough(), fr = d.object({
  type: d.literal("Classification"),
  key: d.string()
}), pr = d.object({
  type: d.literal("Score"),
  score: d.number()
}), mr = d.union([
  fr,
  pr
]), Me = d.object({
  additionalStreetInfo: d.string().optional(),
  city: d.string().optional(),
  country: d.string(),
  email: d.string().optional(),
  firstName: d.string().optional(),
  lastName: d.string().optional(),
  phone: d.string().optional(),
  postalCode: d.string().optional(),
  state: d.string().optional(),
  streetName: d.string().optional()
}), Br = d.object({
  billingAddress: Me.optional(),
  cartState: d.union([
    d.literal("Active"),
    d.literal("Frozen"),
    d.literal("Merged"),
    d.literal("Ordered"),
    d.string()
  ]),
  custom: Ze.optional(),
  customLineItems: d.array(ar),
  discountCodes: d.array(cr),
  id: d.string(),
  lineItems: d.array(sr),
  locale: d.string().optional(),
  shippingAddress: Me.optional(),
  shippingInfo: hr.optional(),
  shippingRateInput: mr.optional(),
  taxedPrice: dr.optional(),
  totalPrice: ve
}).passthrough(), qr = (t) => {
  var r;
  const e = t.find((n) => n.state === "MatchesCart");
  return ((r = e == null ? void 0 : e.discountCode.obj) == null ? void 0 : r.code) || null;
}, Ye = (t, e) => {
  const { pricePerUnit: r, quantity: n } = t;
  if (!r[e])
    return;
  const { centAmount: s } = r[e];
  return s * n;
}, Wr = (t, e) => t.reduce(
  (n, s) => n + (Ye(s, e) || 0),
  0
), Gr = (t, e, r) => {
  const n = t.reduce(
    (s, a) => s + (Ye(a, r) || 0),
    0
  );
  return e - n;
}, Yr = (t, e, r) => {
  var n;
  return e ? (((n = t.pricesAfterDiscount[r]) == null ? void 0 : n.centAmount) || 0) / (100 * e) : 0;
}, j = (t, e, r = null) => {
  var n;
  return ((n = e.custom) == null ? void 0 : n.fields[t]) ?? r;
}, Hr = (t) => j("partnerMemberNumber", t), He = {
  bmsNodeId: 11486062,
  countryAbbreviation: "US",
  countryCode: "US",
  countryName: "United States",
  currencyCode: "USD",
  currencySymbol: "$",
  drupalCountryId: 840,
  localeCode: "en-US"
  /* EN_US */
}, yr = {
  bmsNodeId: 11486497,
  countryAbbreviation: "UK",
  countryCode: "GB",
  countryName: "United Kingdom",
  currencyCode: "GBP",
  currencySymbol: "£",
  drupalCountryId: 826,
  localeCode: "en-GB"
  /* EN_GB */
}, gr = [He, yr], vr = () => He, ae = (t) => gr.find((e) => e.localeCode === t) || vr();
var _r = /* @__PURE__ */ ((t) => (t.SERVICE = "service", t.PACKAGE_PARENT = "package_parent", t.REPLACEMENT_PARENT = "replacement_parent", t.ACCESSORY = "accessory", t.SENSOR = "sensor", t.DYNAMIC_PREBUILT = "prebuilt", t.DYNAMIC_REFURB = "refurb", t.DYNAMIC_UPGRADE = "upgrade", t.DYNAMIC_CUSTOM = "custom", t.DYNAMIC_PLA = "pla", t))(_r || {});
const xr = (t) => (t == null ? void 0 : t.key) === "accessory", br = (t) => (t == null ? void 0 : t.key) === "service", Ae = (t) => (t == null ? void 0 : t.key) === "package_parent", Je = (t) => {
  var e;
  return Ee(t) ? (e = t.productType.obj) == null ? void 0 : e.key : void 0;
}, ie = (t, e, r = null) => {
  var n, s;
  return ((s = (n = e.attributes) == null ? void 0 : n.find((a) => a.name === t)) == null ? void 0 : s.value) ?? r;
}, kr = (t) => !Ee(t), Ee = (t) => "lineItemMode" in t, wr = (t) => t.lineItemMode === "GiftLineItem", Oe = (t) => {
  var r;
  const e = (r = t.productType) == null ? void 0 : r.obj;
  return e ? br(e) : !1;
}, Re = (t) => {
  var r;
  const e = (r = t.productType) == null ? void 0 : r.obj;
  return e ? xr(e) && /^SSPSH(-[A-Z]+)?$/.test(Qe(t)) : !1;
}, Sr = (t) => {
  var r;
  const e = (r = t.productType) == null ? void 0 : r.obj;
  return e ? Ae(e) : !1;
}, Ke = (t) => !!_e(t) && (kr(t) || !Sr(t) && !Oe(t) && !Re(t)), Xe = (t) => {
  var r;
  const e = (r = t.productType) == null ? void 0 : r.obj;
  return e ? Ae(e) && j("product_is_bms", t, !1) : !1;
}, Tr = (t) => {
  var r;
  const e = (r = t.productType) == null ? void 0 : r.obj;
  return e ? Ae(e) && !j("product_is_bms", t, !1) : !1;
}, Ne = (t, e) => {
  const r = _e(t);
  return e.filter(
    (n) => Ke(n) && _e(n) === r && n.id !== t.id
  );
}, Cr = (t, e) => t.map(
  ({ quantity: r, price: n }) => r * n.value.centAmount / e
).reduce((r, n) => r + n, 0), Nr = (t) => t.map((e) => e.totalPrice.centAmount).reduce((e, r) => e + r, 0), _e = (t) => j("package_parent_id", t, ""), Qe = (t) => j("product_key", t, ""), Zr = (t) => ie("weight", t.variant, 0), Ar = (t) => ie("hardware-version", t.variant, ""), Er = (t) => ie("is_air_shipping_prohibited", t.variant, !1), Ie = (t) => ie("is_promo_product", t.variant, !1), Or = (t) => ie("indeterminatePrice", t.variant, !1), Fe = (t) => j("lineItemDisplayName", t, ""), Rr = (t) => j("lineItemSku", t, ""), et = (t) => Fe(t) !== "", jr = (t) => j("packageSource", t, ""), Jr = (t) => t.lineItems.reduce((e, r) => Xe(r) ? [...e, Pr(r, t)] : Tr(r) ? [...e, Mr(r, t)] : Oe(r) ? [...e, Ir(r, t)] : Re(r) ? [...e, Lr(r, t)] : Ke(r) ? e : [...e, Dr(r, t)], Array.of()), Pr = (t, e) => {
  const r = Ne(t, e.lineItems), n = Ne(
    t,
    e.customLineItems || []
  ), s = [...r, ...n], a = Cr(
    r,
    t.quantity
  ), i = Nr(r);
  return oe(
    t,
    ae(e.locale),
    a,
    i,
    s
  );
}, Mr = (t, e) => {
  const r = t.price.value.centAmount, n = t.totalPrice.centAmount, s = Ne(t, e.customLineItems || []);
  return oe(
    t,
    ae(e.locale),
    r,
    n,
    s
  );
}, Ir = (t, e) => {
  const r = t.totalPrice.centAmount;
  return oe(
    t,
    ae(e.locale),
    r,
    r,
    [],
    !0
  );
}, Lr = (t, e) => {
  const r = t.price.value.centAmount, n = t.totalPrice.centAmount;
  return oe(
    t,
    ae(e.locale),
    r,
    n,
    [],
    !0
  );
}, Dr = (t, e) => {
  const r = t.price.value.centAmount, n = t.totalPrice.centAmount;
  return oe(
    t,
    ae(e.locale),
    r,
    n
  );
}, Vr = (t) => {
  if (et(t))
    return {
      packageName: Fe(t),
      packageSku: Rr(t)
    };
}, oe = (t, e, r, n, s = [], a = !1) => {
  const { currencyCode: i, localeCode: o } = e;
  return {
    attributes: {
      hardwareVersion: Ar(t),
      weight: Zr(t)
    },
    disabledQuantityUpdates: a,
    dynamicPackageMeta: Vr(t),
    id: t.id,
    isAirShippingProhibited: Er(t),
    isBackordered: !1,
    isCustomSystem: Xe(t),
    isDynamicPackage: et(t),
    isGift: wr(t) || Ie(t),
    isIndeterminatePrice: Or(t),
    isProInstallation: Re(t),
    isPromoProduct: Ie(t),
    isServicePlan: Oe(t),
    name: t.name,
    packageItems: $r(s),
    packageParentId: _e(t),
    packageSource: jr(t),
    pricePerUnit: {
      [o]: {
        centAmount: r,
        currencyCode: i
      }
    },
    pricesAfterDiscount: {
      [o]: {
        centAmount: n,
        currencyCode: i
      }
    },
    productType: Je(t),
    quantity: t.quantity,
    sku: t.variant.sku
  };
}, $r = (t) => t.map((e) => {
  const r = Qe(e);
  return {
    id: e.id,
    includedInPackage: j(
      "includedInPackage",
      e,
      !1
    ),
    lineItemType: Ee(e) ? "regular" : "custom",
    name: e.name,
    quantity: e.quantity,
    sku: r,
    productType: Je(e)
  };
}), Kr = (t) => t ? t.totalGross.centAmount - t.totalNet.centAmount : 0;
function Ur(t) {
  return t.type === "Classification";
}
const Xr = (t) => (t == null ? void 0 : t.price.centAmount) || 0, Qr = (t) => !t || Ur(t) ? 0 : t.score, Fr = (t) => !t || !t.shippingMethod || t.shippingMethodState !== "MatchesCart" ? null : t.shippingMethodName, en = (t) => !t || !t.shippingMethod || t.shippingMethodState !== "MatchesCart" ? null : t.shippingMethod.id;
export {
  _r as ProductTypes,
  Me as addressSchema,
  er as attributeSchema,
  ve as centPrecisionMoneySchema,
  fr as classificationShippingRateInputSchema,
  Br as ctCartSchema,
  Ze as customFieldsSchema,
  ar as customLineItemSchema,
  cr as discountCodeInfoSchema,
  or as discountCodeReferenceSchema,
  ir as discountCodeSchema,
  qr as getDiscountCode,
  Gr as getDiscountedAmount,
  Yr as getDiscountedPerUnitPrice,
  Hr as getPartnerMemberNumber,
  Ye as getPriceBeforeDiscount,
  Wr as getPricesBeforeDiscount,
  en as getShippingMethodId,
  Fr as getShippingMethodName,
  Xr as getShippingPrice,
  Qr as getShippingRateInput,
  Kr as getTax,
  sr as lineItemSchema,
  We as localizedSchema,
  Ft as priceSchema,
  nr as productTypeReferenceSchema,
  rr as productTypeSchema,
  tr as productVariantSchema,
  pr as scoreShippingRateInputSchema,
  hr as shippingInfoSchema,
  ur as shippingMethodReferenceSchema,
  lr as shippingMethodStateSchema,
  mr as shippingRateInputSchema,
  dr as taxedPriceSchema,
  Jr as transformLineItems,
  Ge as typedMoneySchema
};
